import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import useStyles from './styles';
const KEY_PREFIX = 'subscriptions.scheduleChange.cancel.override';

/** Digits with at most two decimals, which is what an amount of money is here. */
const AMOUNT_PATTERN = /^\d*(\.\d{0,2})?$/;
export const isAmountEntryAllowed = entry => AMOUNT_PATTERN.test(entry);

/**
 * The amount as a number, or null when it is not one yet. An empty field is not an amount: leaving it
 * blank is an unfinished edit, not a waiver, which is typed as a zero.
 */
export const parseAmount = entry => {
  if (!AMOUNT_PATTERN.test(entry) || entry.trim() === '' || entry === '.') {
    return null;
  }
  const amount = Number(entry);
  return Number.isFinite(amount) && amount >= 0 ? amount : null;
};
const formatMoney = amount => "$".concat(amount.toLocaleString('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}));
export const EarlyTerminationAmountField = _ref => {
  let isOverridden = _ref.isOverridden,
    value = _ref.value,
    projectedAmount = _ref.projectedAmount,
    onToggle = _ref.onToggle,
    onChange = _ref.onChange;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const amount = parseAmount(value);
  const isIncomplete = isOverridden && amount === null;
  const helper = (() => {
    if (isIncomplete) return t("".concat(KEY_PREFIX, ".incomplete"));
    if (isOverridden && amount === 0) return t("".concat(KEY_PREFIX, ".helper_waived"));
    if (isOverridden) return t("".concat(KEY_PREFIX, ".helper_set"));
    if (typeof projectedAmount === 'number') {
      return t("".concat(KEY_PREFIX, ".helper_projected"), {
        amount: formatMoney(projectedAmount)
      });
    }
    return t("".concat(KEY_PREFIX, ".helper_default"));
  })();
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.field
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: isOverridden,
      onChange: event => onToggle(event.target.checked),
      size: "small"
    }),
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, t("".concat(KEY_PREFIX, ".toggle")))
  }), isOverridden && /*#__PURE__*/React.createElement(TextField, {
    label: t("".concat(KEY_PREFIX, ".label")),
    placeholder: t("".concat(KEY_PREFIX, ".placeholder")),
    value: value,
    onChange: event => {
      if (isAmountEntryAllowed(event.target.value)) onChange(event.target.value);
    },
    InputProps: {
      startAdornment: /*#__PURE__*/React.createElement("span", {
        className: classes.amountAdornment
      }, "$")
    },
    InputLabelProps: {
      shrink: true
    },
    error: isIncomplete,
    inputProps: {
      inputMode: 'decimal'
    },
    fullWidth: true
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: isIncomplete ? classes.amountError : classes.helper
  }, helper));
};